import { BigNumber } from 'bignumber.js';
import PropTypes from 'prop-types';

import { buildClass } from '../../../libs/classes';
import { cardFinish, language } from '../../../hoc/MtgProvider';

import './SampleTile.css';

/**
 * Sample tile of card
 * @component
 */
export const SampleTile = ({ sample, activeSampleId, updSampleId, cutoffPrice, onClick }) => {
	let re = new RegExp('/normal/', 'g');
	let smallImgUrl = sample.card.image_normal_uri.replace(re, '/small/');
	return (
		<div className={'sample-tile' + getSampleClasses()} onClick={handleClick}>
			<div className={buildClass('name').add(sample.card, `rarity-${sample.card.rarity}`)}>
				{sample.card.name}
			</div>
			<div className="qty-block">
				<div className="qty">×&#8202;{sample.qty}</div>
				<div className="language">{getLanguage()}</div>
				{sample.finish === cardFinish.foil ? (
					<div className="finish foil" title="Card is foil">
						F
					</div>
				) : null}
				{sample.finish === cardFinish.etched ? (
					<div className="finish etched" title="Card has etched finish">
						E
					</div>
				) : null}
			</div>
			{getPriceBlock()}
			<img alt={'Card: ' + sample.card.name} height="204" loading="lazy" src={smallImgUrl} width="146" />
		</div>
	);

	function getSampleClasses() {
		let cls = '';
		if (updSampleId) cls += updSampleId === sample.id ? ' updated' : '';
		if (activeSampleId) cls += activeSampleId === sample.id ? ' active' : '';
		return cls;
	}

	function getLanguage() {
		if (language[sample.language] !== undefined) return <span className={'flag flag-' + sample.language} />;
		return <span title="Unknown language">?</span>;
	}

	// Prepare price block
	function getPriceBlock() {
		if (!sample) return <div className="price" />;
		if (!sample.card) return <div className="price">?</div>;

		let price = BigNumber('0');
		if (sample.finish === cardFinish.nonfoil) {
			price = BigNumber(sample.card.price_usd);
		} else if (sample.finish === cardFinish.foil) {
			price = BigNumber(sample.card.price_usd_foil);
		} else if (sample.finish === cardFinish.etched) {
			price = BigNumber(sample.card.price_usd_etched);
		}
		if (price.lt(cutoffPrice))
			return (
				<div className="price-block cutoff" title={'Value: $' + BigNumber(price).toFormat(2)}>
					<span className="usd">&lt;&nbsp;$&#8202;</span>
					{BigNumber(cutoffPrice).toFormat(2)}
				</div>
			);

		//let total = price.times(sample.qty)

		return (
			<div className="price-block">
				<div className="total" title="Single card price">
					<span className="usd">$&#8202;</span>
					{price.toFormat(2)}
				</div>
			</div>
		);
	}

	function handleClick() {
		onClick(sample);
	}
};

SampleTile.propTypes = {
	// Displayed sample
	sample: PropTypes.object.isRequired,
	// ID of active sample
	activeSampleId: PropTypes.number.isRequired,
	// ID of last updated sample
	updSampleId: PropTypes.number.isRequired,
	// Cutoff price
	cutoffPrice: PropTypes.number.isRequired,
	// Callback function on click
	onClick: PropTypes.func.isRequired,
};

export default SampleTile;
